<template>
	<div class="h100">
		<w-split v-model="splitValueL">
			<div class="h100"
				 slot="left">
				<el-col :span="12"
						class="h100"
						style="border-right:1px solid #eee">
					<tree-table :data="tenantData"
								@row-click="treeTableRowClick"
								ref="treeTable"
								:type="'tenant'"></tree-table>
				</el-col>
				<el-col :span="12"
						class="h100"
						style="border-right:1px solid #eee">
					<tenantTree :data="roles"
								:id="treeTableId"
								ref="tenantTree"></tenantTree>
				</el-col>
			</div>
			<div class="h100"
				 slot="right">
				<el-col :span="12"
						class="h100"
						style="border-right:1px solid #eee">
					<tree-table :data="mainData"
								@row-click="treeTableRowClick"
								ref="treeTable"
								:type="'main'"></tree-table>
				</el-col>
				<el-col :span="12"
						class="h100"
						style="border-right:1px solid #eee">
					<mainTree :data="mainRoles"
							  :id="mainTableId"
							  ref="mainTree"></mainTree>
				</el-col>
			</div>
		</w-split>
	</div>
</template>

<script>
import wSplit from '@/components/split/split'
import TreeTable from './treeTable'
import tenantTree from './tenantTree'
import mainTree from './mainTree'
import {
	selectTenantPreinstall,
	selectLimitall
} from 'api/system/defaultRole'

export default {
	name: 'defaultRole',
	components: { wSplit, TreeTable, tenantTree, mainTree },
	provide() {
		return {
			selectTenantPreinstall: this.selectTenantPreinstall,
			selectLimitall: this.selectLimitall
		}
	},
	data() {
		return {
			splitValueL: 0.5,
			treeTableId: '',
			tenantData: [],
			roles: [],
			mainData: [],
			mainRoles: [],
			mainTableId: ''
		}
	},
	methods: {
		// 请求租户角色预设列表
		selectTenantPreinstall(first) {
			selectTenantPreinstall().then(res => {
				// console.log(res.data)
				this.tenantData = res.data.preinstalls
				if (first) {
					this.treeTableId = this.tenantData[0].id
					this.$refs.tenantTree.getRoleListById(this.treeTableId)
				}
				this.roles = this.$utils.toArrayTree(res.data.roles, {
					parentKey: 'parent_id'
				})
			})
		},

		// 获取主体列表 包含角色列表
		selectLimitall(first) {
			selectLimitall().then(res => {
				console.log(res.data)
				this.mainData = this.$utils.toArrayTree(res.data.limits, {
					parentKey: 'parent_id'
				})
				this.mainRoles = this.$utils.toArrayTree(res.data.roles, {
					parentKey: 'parent_id'
				})
				if (first) {
					this.mainTableId = this.mainData[0].id
					this.$refs.mainTree.getRolesByLimitId(this.mainTableId)
				}
			})
		},

		treeTableRowClick(id, type) {
			if (type === 'tenant') {
				// 租户
				this.treeTableId = id
				this.$refs.tenantTree.getRoleListById(this.treeTableId)
			} else {
				// 主体
				this.mainTableId = id
				this.$refs.mainTree.getRolesByLimitId(this.mainTableId)
			}
		}
	},
	created() {
		this.selectTenantPreinstall(1)
		this.selectLimitall(1)
	}
}
</script>

